const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.riotinto.forwoodsafety.com',
    USER_TOKEN_URL: 'https://de4ushaec8.execute-api.us-east-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-east-1',
    URL: 'https://8sbcserw4a.execute-api.us-east-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.riotinto.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.riotinto.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.riotinto.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.riotinto.forwoodsafety.com',
    WEBSOCKET: 'wss://w0ii35o49j.execute-api.us-east-1.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
